import { useCallback, useReducer, useState } from 'react';

import useMountedState from './use-mounted-state';

const useAsyncSafeState = (...args) => {
  const isMounted = useMountedState();
  const [value, setValue] = useState(...args);
  const asyncSafeSetValue = useCallback((newValue) => {
    if (isMounted.current) {
      return setValue(newValue);
    }
    // eslint-disable-next-line
  }, []);

  return [value, asyncSafeSetValue];
};

const useAsyncSafeReducer = (...args) => {
  const isMounted = useMountedState();
  const [state, dispatch] = useReducer(...args);
  const asyncSafeDispatch = useCallback((action) => {
    if (isMounted.current) {
      return dispatch(action);
    }
    // eslint-disable-next-line
  }, []);

  return [state, asyncSafeDispatch];
};

export { useAsyncSafeReducer, useAsyncSafeState };
